<template>

  <div v-if="this.$store.state.fetchGeschichteComplete == true" class="mt-8">

    <div class="bg-beige-100 shadow-md rounded-lg max-w-2xl history w-ful lg:w-1/2 p-6 rounded-3xl mx-auto" v-html="$store.state.geschichte[0].geschichte">

    </div>

  </div>
</template>

<script>
export default {
  components: {

  },
  name: 'Geschichte',
  props: {

  },
  data() {
    return {

    }
  },
  methods: {

    compare(a, b) {
      if (a.text < b.text) {
        return -1;
      }
      if (a.text > b.text) {
        return 1;
      }
      // a muss gleich b sein
      return 0;
    },


  },
  mounted: function(){

  },

  computed: {

    sortDownloads() {
      // console.log(this.data.slice().sort(this.compare));

      return this.$store.state.downloads.slice().sort(this.compare);
    },

    sortVerein() {
      // console.log(this.data.slice().sort(this.compare));

      var result = this.$store.state.verein.filter(obj => {
        return obj.id === 1;
      })

      // console.log(result);

      return result
    },

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

.customcss >>> h1{
  font-size: 100px !important;
  color: red;
}

p{
  margin-bottom: 100px !important;
}

</style>
